<template>
  <div class="md:grid flex flex-col filter-container gap-3 w-full mb-4">
    <div class="flex flex-col">
      <p class="text-xs mb-2 font-medium">
        {{ $t('WORK_ORDER_REPORTS.SELECT_PERIOD') }}
      </p>
      <div class="multiselect-wrap--small">
        <Datepicker
          :value="period"
          type="month"
          :not-auto-close="true"
          class="w-full h-[46px]"
          :placeholder="$t('REPORT.CUSTOM_DATE_RANGE.PLACEHOLDER')"
          @change="updatePeriod"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vue2-datepicker';

export default {
  components: { Datepicker },
  props: {
    period: {
      type: Date,
      required: true,
    },
  },
  methods: {
    updatePeriod(value) {
      this.$emit('update-period', value);
    },
  },
};
</script>

<style scoped>
.filter-container {
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
}
</style>
